"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepsContext = exports.Step = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var Item_1 = tslib_1.__importDefault(require("./Item"));
var Item_2 = require("./Item");
Object.defineProperty(exports, "Step", { enumerable: true, get: function () { return tslib_1.__importDefault(Item_2).default; } });
exports.stepsContext = react_1.createContext({
    current: 0,
    status: 'process'
});
function Steps(props) {
    var _a;
    var className = props.className, style = props.style, children = props.children, _b = props.current, current = _b === void 0 ? 0 : _b, _c = props.direction, direction = _c === void 0 ? 'horizontal' : _c, _d = props.status, status = _d === void 0 ? 'process' : _d, _e = props.labelPlacement, labelPlacement = _e === void 0 ? 'bottom' : _e, onChange = props.onChange, rootHtmlProps = props.rootHtmlProps;
    var prefix = ConfigProvider_1.usePrefix('steps');
    var labelRightDisplayed = direction === 'horizontal' && labelPlacement === 'right';
    var stepsClassName = classnames_1.default(prefix, className, (_a = {},
        _a[utils_1.concat(prefix, direction)] = true,
        _a[utils_1.concat(prefix, 'clickable')] = onChange != null,
        _a[utils_1.concat(prefix, 'label-placement', labelPlacement)] = labelRightDisplayed,
        _a), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    return (react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: stepsClassName, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }),
        react_1.default.createElement(exports.stepsContext.Provider, { value: { current: current, status: status, onChange: onChange } }, react_1.default.Children.map(children, function (item, number) {
            if (!react_1.isValidElement(item)) {
                return null;
            }
            var description = item.props.description;
            if (utils_1.isDev) {
                if (item.type !== Item_1.default) {
                    console.warn('`Steps` only accepts children of type `Step`.');
                }
                if (labelRightDisplayed && description != null) {
                    console.warn('`description` will not be displayed when `labelPlacement` value is `right`.');
                }
            }
            return react_1.cloneElement(item, { number: number });
        }))));
}
exports.default = Steps;
//# sourceMappingURL=index.js.map